import React, { useState, useEffect } from 'react';
import Topbar from './Topbar';
import Navbar from './Navbar';
import Footer from './Footer';
import StickyCta from '../ui/StickyCta';

const TOPBAR_H = 40;  // px — must match Topbar padding*2 + content
const NAVBAR_H = 72;  // px — must match Navbar .inner height

export default function Layout({ children }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > TOPBAR_H);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // When at top: topbar (40) + navbar (72) = 112px
  // When scrolled: topbar slides away, navbar sits at 0, offset = 72px
  const bodyOffset = scrolled ? NAVBAR_H : TOPBAR_H + NAVBAR_H;

  return (
    <>
      <Topbar hidden={scrolled} />
      <Navbar scrolled={scrolled} />
      <main style={{ paddingTop: bodyOffset }}>{children}</main>
      <Footer />
      <StickyCta />
    </>
  );
}
